import React, { useEffect, useState, useRef } from "react";
import "./AddBudgetForm.css";
import { Alert, Form, Modal, Container, Row, Col } from "react-bootstrap";
import {
  get_schemes,
  add_budget,
  getActivity,
  getSubActivity,
  add_subhead_budget,
} from "../../../helper/Api";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { DeleteForever } from "@mui/icons-material";
import { toast } from "react-toastify";
import { Navigate, useNavigate } from "react-router-dom";
import AddBudgetPreview from "../../../components/Modal/AddBudgetPreview";
import AddIcon from "@mui/icons-material/Add";
import CustomBreadcrumbs from "../../Tools/Breadcumbs";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField
} from "@mui/material";
const AddBudgetForm = () => {
  const { financialYears, authData } = useSelector((state) => state.authData);
  const provisionalBudget = useRef(0);
  const releaseBudget = useRef(0);
  const fy_list = financialYears.payload.fy_list;
  const [schemes, set_schemes] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [activity, setActivity] = useState([]);
  const [subActivity, setSubActivity] = useState([]);
  const [activityEnable, setactivityEnable] = useState("0");
  const [controlLevel, setControlLevel] = useState("0");
  const [min_max_date, setMinMaxDate] = useState({
    min: null,
    max: null,
  });
  const [subheadsList, set_subheadsList] = useState([]);
  const [error, setError] = useState({
    status: false,
    msg: "",
  });
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    scheme_id: null,
    sub_heads: [
      {
        name: "",
        code: "",
        financial_year: "",
        budget: "",
        provisional_budget: "",
        activity: [
          {
            activity_id: "",
            subactivity_id: "",
            provisional_budget: 0,
            budget: 0,
          },
        ],
      },
    ],
    is_activity_enable: "",
    added_by: authData.user.id,
    newSub_heads: [],
    attachment: [],
  });
  const [formSubheadData, setFormSubheadData] = useState({
    scheme_id: "",
    name: "",
    code: "",
  });

  const navigate = useNavigate();

  const fetch_list = async () => {
    const schemes_list = await get_schemes();
    if (schemes_list.data.status) {
      set_schemes(schemes_list.data.schemes);
    } else {
      set_schemes([]);
    }
  };

  useEffect(() => {
    fetchActivity();
    fetchSubActivity();
    fetch_list();
  }, []);

  const get_schemeName = (id) => {
    if (id) {
      const filter = schemes.filter((scheme) => scheme.id == id);
      if (filter.length > 0) {
        return filter[0].name;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const get_subheadName = (id) => {
    if (id) {
      const filter = subheadsList.filter((subhead) => subhead.id == id);
      if (filter.length > 0) {
        return filter[0];
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const resetFormData = () => {
    setFormData({
      scheme_id: null,
      sub_heads: [
        {
          name: "",
          id: "",
          financial_year: "",
          budget_order_no: "",
          budget_order_date: "",
          budget: "",
        },
      ],
      added_by: authData.user.id,
      attachment: [],
    });
  };

  const handleSchemFormData = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormData({ ...formData, [name]: value });
    if (name == "scheme_id") {
      if (value) {
        const filter = schemes.filter((scheme) => scheme.id == value);
        setactivityEnable(filter[0].is_activity_active);
        setControlLevel(filter[0].monitoring_level);
        if (filter.length > 0) {
          set_subheadsList(filter[0].sub_head_list);
        } else {
          set_subheadsList([]);
        }
      } else {
        setactivityEnable("0");
        setControlLevel("");
        set_subheadsList([]);
      }
    } else if (name == "financial_year") {
      const filter = fy_list.filter((fy) => fy.id == value);
      if (filter.length > 0) {
        setMinMaxDate({
          min: `${filter[0].start_year}-04-01`,
          max: `${filter[0].end_year}-03-31`,
        });
      } else {
        setMinMaxDate({
          min: null,
          max: null,
        });
      }
    }
  };

  const handleSubHeadChange = (index, field, value) => {
    const newSubHeads = [...formData.sub_heads];
    newSubHeads[index][field] = value;
    setFormData({
      ...formData,
      sub_heads: newSubHeads,
    });
    if (field === "provisional_budget") {
      total_provisional_budget();
    }
    if (field === "budget") {
      total_scheme_budget();
    }
  };

  const handleAddSubHead = () => {
    const newSubHeads = [...formData.sub_heads];
    if (activityEnable == "1" && controlLevel == "1") {
      newSubHeads.push({
        name: "",
        id: "",
        financial_year: "",
        budget: "",
        budget_order_no: "",
        budget_order_date: "",
        activity: [
          {
            activity_id: "",
            subactivity_id: "",
            provisional_budget: "",
            budget: "",
          },
        ],
      });
    } else {
      newSubHeads.push({
        name: "",
        id: "",
        financial_year: "",
        budget: "",
        budget_order_no: "",
        budget_order_date: "",
      });
    }
    setFormData({
      ...formData,
      sub_heads: newSubHeads,
    });
  };
  const handleNewSubHeadChange = (index, field, value) => {
    const newSubHeads = [...formData.newSub_heads];
    newSubHeads[index][field] = value;
    setFormData({
      ...formData,
      newSub_heads: newSubHeads,
    });
    if (field === "provisional_budget") {
      total_provisional_budget(true);
    }
    if (field === "budget") {
      total_scheme_budget(true);
    }
  };
  const deleteNewSubhead = (index) => {
    const updatedSubHeads = [...formData.newSub_heads];
    updatedSubHeads.splice(index, 1);
    setFormData({
      ...formData,
      newSub_heads: updatedSubHeads,
    });
  };
  const handleAddNewSubHead = () => {
    const newSubHeads = [...formData.newSub_heads];
    if (activityEnable == "1" && controlLevel == "1") {
      newSubHeads.push({
        name: "",
        code: "",
        financial_year: "",
        budget: "",
        activity: [
          {
            activity_id: "",
            subactivity_id: "",
            provisional: 0,
            release: 0,
          },
        ],
      });
    } else {
      newSubHeads.push({
        name: "",
        code: "",
        financial_year: "",
        budget: "",
      });
    }
    setFormData({
      ...formData,
      newSub_heads: newSubHeads,
    });
  };
  const handleAttachmentChange = (event) => {
    const files = event.target.files;
    setFormData({
      ...formData,
      attachment: files,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const post_data = new FormData();
    for (let i = 0; i < formData.attachment.length; i++) {
      post_data.append("attachment[]", formData.attachment[i]);
    }
    post_data.append("scheme_id", formData.scheme_id);
    post_data.append("financial_year", formData.financial_year);
    post_data.append("budget_order_no", formData.budget_order_no);
    post_data.append("budget_order_date", formData.budget_order_date);
    post_data.append("sub_heads", JSON.stringify(formData.sub_heads));
    post_data.append("newSub_heads", JSON.stringify(formData.newSub_heads));
    post_data.append("added_by", authData.user.id);
    try {
      setLoading(true);
      const budgetResponse = await add_budget(post_data);
      const budgetResponseData = budgetResponse.data;
      if (budgetResponseData.status) {
        setLoading(false);
        setShowPreview(false);
        resetFormData();
        toast.success(budgetResponseData.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        navigate("/budgets");
      } else {
        setLoading(false);
        toast.error(budgetResponseData.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      setLoading(false);
      setError({
        status: false,
        msg: "something went wrong...",
      });
    }
  };
  const deleteSubhead = (index) => {
    const updatedSubHeads = [...formData.sub_heads];
    updatedSubHeads.splice(index, 1);
    setFormData({
      ...formData,
      sub_heads: updatedSubHeads,
    });
  };
  function total_scheme_budget(isNewSubhead = false) {
    const subheads =
      isNewSubhead === true
        ? [...formData.newSub_heads, ...formData.sub_heads]
        : formData.sub_heads;
    let total_budget = 0;
    subheads.forEach((sub) => {
      if (sub.budget) {
        total_budget += parseFloat(sub.budget);
      }
    });
    releaseBudget.current = total_budget;
  }
  const total_provisional_budget = (isNewSubhead = false) => {
    const subheads =
      isNewSubhead === true
        ? [...formData.newSub_heads, ...formData.sub_heads]
        : formData.sub_heads;
    let total_budget = 0;
    subheads.forEach((sub) => {
      if (sub.provisional_budget) {
        total_budget += parseFloat(sub.provisional_budget);
      }
    });
    provisionalBudget.current = total_budget;
  };
  const fetchActivity = async () => {
    try {
      const resp = await getActivity();
      if (resp.data.status) {
        setActivity(resp.data.result);
      }
    } catch (error) {
      setActivity([]);
    }
  };
  const fetchSubActivity = async () => {
    try {
      const resp = await getSubActivity();
      if (resp.data.status) {
        setSubActivity(resp.data.result);
      }
    } catch (error) {
      setSubActivity([]);
    }
  };
  const findSubActivitiesById = (id) => {
    let listData = subActivity;
    return listData.filter((subActivity) => subActivity.activity_id === id);
  };
  const handleActivityChange = (subHeadIndex, activityIndex, e, activityId) => {
    const { name, value } = e.target;
    const SubHeads = [...formData.sub_heads];
    if (activityId) {
      const activityValid = SubHeads[subHeadIndex].activity.find(
        (item) =>
          item.subactivity_id === value && item.activity_id === activityId
      );
      if (activityValid) {
        return alert("Sub-activity already selected");
      }
    }
    setFormData((prevFormData) => {
      const updatedSubHeads = prevFormData.sub_heads.map((subHead, sIdx) => {
        if (sIdx === subHeadIndex) {
          const updatedActivities = subHead.activity.map((activity, aIdx) => {
            if (aIdx === activityIndex) {
              const updatedActivity = {
                ...activity,
                [name]: value,
              };
              if (name === "activity_id") {
                updatedActivity.subactivity_id = "";
              }
              return updatedActivity;
            }
            return activity;
          });
          return {
            ...subHead,
            activity: updatedActivities,
          };
        }
        return subHead;
      });
      return {
        ...prevFormData,
        sub_heads: updatedSubHeads,
      };
    });
  };
  const handleNewActivityChange = (
    subHeadIndex,
    activityIndex,
    e,
    activityId
  ) => {
    const { name, value } = e.target;
    const SubHeads = [...formData.newSub_heads];
    if (activityId) {
      const activityValid = SubHeads[subHeadIndex].activity.find(
        (item) =>
          item.subactivity_id === value && item.activity_id === activityId
      );
      if (activityValid) {
        return alert("Sub-activity already selected");
      }
    }
    setFormData((prevFormData) => {
      const updatedSubHeads = prevFormData.newSub_heads.map((subHead, sIdx) => {
        if (sIdx === subHeadIndex) {
          const updatedActivities = subHead.activity.map((activity, aIdx) => {
            if (aIdx === activityIndex) {
              const updatedActivity = {
                ...activity,
                [name]: value,
              };
              if (name === "activity_id") {
                updatedActivity.subactivity_id = "";
              }
              return updatedActivity;
            }
            return activity;
          });
          return {
            ...subHead,
            activity: updatedActivities,
          };
        }
        return subHead;
      });
      return {
        ...prevFormData,
        newSub_heads: updatedSubHeads,
      };
    });
  };
  const addNewActivity = (index, type) => {
    const newActivity = {
      activity_id: "",
      subactivity_id: "",
      provisional_budget: 0,
      budget: 0,
    };
    if (type == "newsubhead") {
      setFormData((prevFormData) => {
        const updatedSubHeads = prevFormData.newSub_heads.map(
          (subHead, idx) => {
            if (idx === index && subHead.activity) {
              return {
                ...subHead,
                activity: [...subHead.activity, newActivity],
              };
            }
            return subHead;
          }
        );

        return {
          ...prevFormData,
          newSub_heads: updatedSubHeads,
        };
      });
    } else {
      setFormData((prevFormData) => {
        const updatedSubHeads = prevFormData.sub_heads.map((subHead, idx) => {
          if (idx === index && subHead.activity) {
            return {
              ...subHead,
              activity: [...subHead.activity, newActivity],
            };
          }
          return subHead;
        });

        return {
          ...prevFormData,
          sub_heads: updatedSubHeads,
        };
      });
    }
  };
  const deleteNewActivity = (index, activityIndex, type) => {
    if (type == "newsubhead") {
      if (formData.newSub_heads[index].activity.length > 1) {
        setFormData((prevFormData) => {
          const updatedSubHeads = prevFormData.newSub_heads.map(
            (subHead, idx) => {
              if (idx === index && subHead.activity) {
                const updatedActivities = [...subHead.activity];
                updatedActivities.splice(activityIndex, 1);
                return {
                  ...subHead,
                  activity: updatedActivities,
                };
              }
              return subHead;
            }
          );
          return {
            ...prevFormData,
            newSub_heads: updatedSubHeads,
          };
        });
      }
    } else {
      if (formData.sub_heads[index].activity.length > 1) {
        setFormData((prevFormData) => {
          const updatedSubHeads = prevFormData.sub_heads.map((subHead, idx) => {
            if (idx === index && subHead.activity) {
              const updatedActivities = [...subHead.activity];
              updatedActivities.splice(activityIndex, 1);
              return {
                ...subHead,
                activity: updatedActivities,
              };
            }
            return subHead;
          });
          return {
            ...prevFormData,
            sub_heads: updatedSubHeads,
          };
        });
      }
    }
  };
  const previewhandler = (e) => {
    e.preventDefault();
    if (activityEnable == "1" && controlLevel == "1") {
      const isValid = handleAmountValidation();
      if (isValid) {
        setShowPreview(true);
      }
    } else {
      setShowPreview(true);
    }
  };

  const handleSubheadBudget = (index, activityIndex, e) => {
    const { name, value } = e.target;
    let totalProvisionalBudget = 0;
    let totalBudget = 0;
    formData.sub_heads[index].activity.forEach((item, activityI) => {
      if (activityI !== activityIndex) {
        totalProvisionalBudget += parseFloat(item.provisional_budget || 0);
        totalBudget += parseFloat(item.budget || 0);
      }
    });
    if (name === "provisional_budget") {
      totalProvisionalBudget = totalProvisionalBudget + Number(value);
      if (totalProvisionalBudget > formData.sub_heads[index][name]) {
        return alert("Total provisional budget exceeds the allowed amount.");
      }
    }
    if (name === "budget") {
      totalBudget = totalBudget + Number(value);
      if (totalBudget > formData.sub_heads[index][name]) {
        return alert("Total budget exceeds the allowed amount.");
      }
    }
    setFormData((prevFormData) => {
      const updatedSubHeads = prevFormData.sub_heads.map((subHead, sIdx) => {
        if (sIdx === index) {
          const updatedActivities = subHead.activity.map((activity, aIdx) => {
            if (aIdx === activityIndex) {
              const updatedActivity = {
                ...activity,
                [name]: value,
              };
              return updatedActivity;
            }
            return activity;
          });
          return {
            ...subHead,
            activity: updatedActivities,
          };
        }
        return subHead;
      });
      return {
        ...prevFormData,
        sub_heads: updatedSubHeads,
      };
    });
  };
  const handleNewSubheadBudget = (index, activityIndex, e) => {
    const { name, value } = e.target;
    let totalProvisionalBudget = 0;
    let totalBudget = 0;
    formData.newSub_heads[index].activity.forEach((item) => {
      totalProvisionalBudget += parseFloat(item.provisional_budget || 0);
      totalBudget += parseFloat(item.budget || 0);
    });
    if (name === "provisional_budget") {
      totalProvisionalBudget = totalProvisionalBudget + Number(value);
      if (totalProvisionalBudget >= formData.newSub_heads[index][name]) {
        return alert("Total provisional budget exceeds the allowed amount.");
      }
    }
    if (name === "budget") {
      totalBudget = totalBudget + Number(value);
      if (totalBudget >= formData.newSub_heads[index][name]) {
        return alert("Total budget exceeds the allowed amount.");
      }
    }
    setFormData((prevFormData) => {
      const updatedSubHeads = prevFormData.newSub_heads.map((subHead, sIdx) => {
        if (sIdx === index) {
          const updatedActivities = subHead.activity.map((activity, aIdx) => {
            if (aIdx === activityIndex) {
              const updatedActivity = {
                ...activity,
                [name]: value,
              };
              return updatedActivity;
            }
            return activity;
          });
          return {
            ...subHead,
            activity: updatedActivities,
          };
        }
        return subHead;
      });
      return {
        ...prevFormData,
        newSub_heads: updatedSubHeads,
      };
    });
  };
  const handleClose = () => {
    setShowModel(false);
  };
  const openModel = () => {
    setShowModel(true);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormSubheadData({ ...formSubheadData, [name]: value });
  };
  const handleSubhead = async (e) => {
    e.preventDefault();
    try {
      const resp = await add_subhead_budget(formSubheadData);
      if (resp.data.status) {
        fetch_list();
        setShowModel(false);
      }
    } catch (error) {
      setLoading(false);
      setError({
        status: false,
        msg: "something went wrong...",
      });
    }
  };
  const handleAmountValidation = () => {
    const errors = [];
    formData.sub_heads.forEach((subhead) => {
      const totalActivityProvisionalBudget = subhead.activity.reduce(
        (sum, activity) => sum + parseFloat(activity.provisional_budget || 0),
        0
      );
      const totalActivityBudget = subhead.activity.reduce(
        (sum, activity) => sum + parseFloat(activity.budget || 0),
        0
      );
      const subheadProvisionalBudget = parseFloat(
        subhead.provisional_budget || 0
      );
      const subheadBudget = parseFloat(subhead.budget || 0);

      if (subheadProvisionalBudget !== totalActivityProvisionalBudget) {
        errors.push({
          id: subhead.id,
          field: "provisional_budget",
          message: `Provisional budget does not match the total of its activities.`,
        });
      }

      if (subheadBudget !== totalActivityBudget) {
        errors.push({
          id: subhead.id,
          field: "budget",
          message: `Budget does not match the total of its activities.`,
        });
      }
    });
    if (errors.length) {
      const errorMessages = errors.map((err) => `${err.message}`).join("\n");

      toast.error(`${errorMessages}`, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 5000, // optional: closes after 5 seconds
      });
      return false;
    } else {
      return true;
    }
  };

  const linksArray = [
    {
      href: "/budgets",
      label: "Budgets",
    },
  ];

  return (
    <>
      <div>
        <div className="row" style={{padding: '10px 16px'}}>
          <div className="col-md-6">
            <h4> Add Budget</h4>
            <CustomBreadcrumbs linksArray={linksArray} title="Add Budget" />
          </div>
          <div className="col-md-6">
            <div
              className="d-flex gap-2"
              style={{ width: "auto", float: "right" }}
            >
              <button
                type="submit"
                className="navigation_button"
                onClick={() => navigate("/add-subhead")}
              >
                <span className="fs-14px">Add Subhead</span>
              </button>
              <button
                type="submit"
                className="submit_button"
                onClick={previewhandler}
              >
                <span className="fs-14px">Save</span>
              </button>
            </div>
          </div>
        </div>
        <AddBudgetPreview
          showPreview={showPreview}
          setShowPreview={setShowPreview}
          formData={formData}
          handleSubmit={handleSubmit}
          schemes={schemes}
          subheadsList={subheadsList}
          financialYears={fy_list}
          total_scheme_budget={releaseBudget}
          activity={activity}
          subActivity={subActivity}
        />
        <div className="p-3">
          <div className="row">
            {error.status && (
              <Alert
                variant="success"
                onClose={() => setError({ status: false, msg: "" })}
                dismissible
              >
                {error.msg}
              </Alert>
            )}
            {/* <Form onSubmit={previewhandler}> */}
            <div className="col-md-12">
              <div className="card" style={{padding: '0px 12px', borderRadius: "0px"}}>
                <div className="row">
                    <div className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden">
                        <span
                            className="fs-14px white-space-nowrap overflow-x-hidden"
                            style={{ width: "95%", fontStyle: "italic" }}
                        >
                            <span
                            className="fs-14px white-space-nowrap overflow-x-hidden "
                            style={{ width: "95%" }}
                            >
                            <span
                                className="fw-600 fs-16px"
                                style={{ fontStyle: "normal" }}
                            >
                                General
                            </span>
                            </span>
                        </span>
                    </div>
                    <div className="col-sm-12 p-2">
                        <FormControl fullWidth>
                            <InputLabel id="financial_year_label">Financial Year *</InputLabel>
                            <Select
                                labelId="financial_year_label"
                                id="financial_year_id"
                                value={formData.financial_year || ""}
                                label="Financial Year *"
                                name="financial_year"
                                onChange={handleSchemFormData}
                            >
                                {fy_list.map((fy) => (
                                    <MenuItem value={fy.id} key={fy.id}>
                                        {fy.year}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>

                    <div className="col-sm-12 p-2">
                        <FormControl fullWidth>
                            <InputLabel id="scheme-namelabel">Scheme</InputLabel>
                            <Select
                                labelId="scheme-namelabel"
                                id="scheme-name-select"
                                value={formData.scheme_id || ""}
                                label="Scheme"
                                name="scheme_id"
                                onChange={handleSchemFormData}
                            >
                                {schemes.map((scheme) => {
                                    return (
                                        scheme.l2_status == 1 &&
                                        scheme.l3_status == 1 && (
                                        <MenuItem value={scheme.id} key={scheme.id}>
                                            {scheme.code} || {scheme.name} 
                                        </MenuItem> ))
                                })}
                            </Select>
                        </FormControl>
                    </div>

                    <div className="col-sm-6 p-2">
                        <FormControl fullWidth>
                            <TextField
                                id="budget_order_no"
                                label="Budget Order No"
                                variant="outlined"
                                type="text"
                                name="budget_order_no"
                                value={formData.budget_order_no || ""}
                                onChange={handleSchemFormData}
                                required
                            />
                        </FormControl>
                    </div>
                    <div className="col-sm-6 p-2">
                        <FormControl fullWidth>
                            <TextField
                                type="date"
                                id="budget_order_date"
                                label="Budget Order Date"
                                name="budget_order_date"
                                value={formData.budget_order_date}
                                onChange={handleSchemFormData}
                                InputLabelProps={{ shrink: true }}
                                required
                            />
                        </FormControl>
                    </div>

                    <div className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden">
                        <span
                            className="fs-14px white-space-nowrap overflow-x-hidden"
                            style={{ width: "95%", fontStyle: "italic" }}
                        >
                            <span
                            className="fs-14px white-space-nowrap overflow-x-hidden "
                            style={{ width: "95%" }}
                            >
                            <span
                                className="fw-600 fs-16px"
                                style={{ fontStyle: "normal" }}
                            >
                                Subhead
                            </span>
                            </span>
                        </span>
                    </div>
                    {formData.sub_heads.map((subHead, i) => {
                    return (
                        <>
                                <div className="col-sm-6 p-2">
                                    <FormControl fullWidth>
                                        <InputLabel id="subhead_code_label">Subhead Code</InputLabel>
                                        <Select
                                            labelId="subhead_code_label"
                                            id="id"
                                            value={formData.sub_heads[i].id || ""}
                                            label="Subhead Code *"
                                            name="id"
                                            onChange={(e) =>handleSubHeadChange(i,"id",e.target.value)}
                                        >
                                            {subheadsList.map((subhead) => (
                                                <MenuItem
                                                    value={subhead.id}
                                                    key={subhead.id}
                                                >
                                                    {subhead.code}
                                                </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-sm-6 p-2">
                                    <FormControl fullWidth>
                                        <TextField
                                            id="subhead_name"
                                            label="Subhead Name"
                                            variant="outlined"
                                            type="text"
                                            value={get_subheadName(formData.sub_heads[i].id).name || ""}
                                            InputLabelProps={{ shrink: get_subheadName(formData.sub_heads[i].id).name ? true : false }}
                                        />
                                    </FormControl>
                                </div>
                                <div className="col-sm-6 p-2">
                                    <FormControl fullWidth>
                                        <TextField
                                            type="date"
                                            id="budget_date"
                                            label="Budget Date"
                                            name="budget_date"
                                            max={min_max_date.max}
                                            min={min_max_date.min}
                                            value={subHead.budget_date}
                                            onChange={(e) => handleSubHeadChange(i,"budget_date",e.target.value)
                                        }
                                            InputLabelProps={{ shrink: true }}
                                            required
                                        />
                                    </FormControl>
                                </div>
                                <div className="col-sm-6 p-2"></div>

                                <div className="col-sm-6 p-2">
                                    <FormControl fullWidth>
                                        <TextField
                                            type="number"
                                            id="provisional_budget"
                                            label="Provisional Budget"
                                            name="provisional_budget"
                                            value={formData.sub_heads[i].provisional_budget || 0}
                                            onChange={(e) => handleSubHeadChange(i,"provisional_budget",e.target.value)
                                        }
                                            InputLabelProps={{ shrink: true }}
                                            required
                                        />
                                    </FormControl>
                                </div>
                                <div className="col-sm-6 p-2">
                                    <FormControl fullWidth>
                                        <TextField
                                            type="number"
                                            id="budget"
                                            label="Released Budget"
                                            name="budget"
                                            value={formData.sub_heads[i].budget || 0}
                                            onChange={(e) => handleSubHeadChange(i,"budget",e.target.value)
                                        }
                                            InputLabelProps={{ shrink: true }}
                                            required
                                        />
                                    </FormControl>
                                </div>
                                {activityEnable == "1" && controlLevel == "1" && (
                                    <div className="row">
                                        <table className="table table-bordered">
                                        <thead className="text-center-custom">
                                            <tr>
                                            <th scope="col">Activity</th>
                                            <th scope="col">Subactivity</th>
                                            {/* <th scope="col">Provisioned</th> */}
                                            <th scope="col">
                                                Provision budget
                                            </th>
                                            {/* <th scope="col">Release</th> */}
                                            <th scope="col">Release budget</th>
                                            <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-center-custom">
                                            {subHead?.activity.map(
                                            (activityData, index) => (
                                                <tr key={index}>
                                                <td>
                                                    <select
                                                    className="form-control"
                                                    name="activity_id"
                                                    value={
                                                        activityData.activity_id
                                                    }
                                                    onChange={(e) =>
                                                        handleActivityChange(
                                                        i,
                                                        index,
                                                        e
                                                        )
                                                    }
                                                    >
                                                    <option value="">
                                                        ---Select---
                                                    </option>
                                                    {activity.map((e) => (
                                                        <option
                                                        key={e.id}
                                                        value={e.id}
                                                        >
                                                        {e.activity}
                                                        </option>
                                                    ))}
                                                    </select>
                                                </td>
                                                <td>
                                                    <select
                                                    className="form-control"
                                                    name="subactivity_id"
                                                    value={
                                                        activityData.subactivity_id
                                                    }
                                                    onChange={(e) =>
                                                        handleActivityChange(
                                                        i,
                                                        index,
                                                        e,
                                                        activityData.activity_id
                                                        )
                                                    }
                                                    >
                                                    <option value="">
                                                        ---Select---
                                                    </option>
                                                    {findSubActivitiesById(
                                                        activityData.activity_id
                                                    ).map((e) => (
                                                        <option
                                                        key={e.id}
                                                        value={e.id}
                                                        >
                                                        {e.subactivity}
                                                        </option>
                                                    ))}
                                                    </select>
                                                </td>
                                                {/* <td>{subHead.provisional_budget}</td> */}
                                                <td>
                                                    <input
                                                    type="number"
                                                    className="form-control"
                                                    name="provisional_budget"
                                                    placeholder="Enter Provision Budget"
                                                    disabled={
                                                        subHead.provisional_budget <=
                                                        0
                                                    }
                                                    value={
                                                        activityData.provisional_budget
                                                    }
                                                    onChange={(e) =>
                                                        handleSubheadBudget(
                                                        i,
                                                        index,
                                                        e
                                                        )
                                                    }
                                                    ></input>
                                                </td>
                                                {/* <td>{subHead.budget}</td> */}
                                                <td>
                                                    <input
                                                    type="number"
                                                    className="form-control"
                                                    name="budget"
                                                    placeholder="Enter Release Budget"
                                                    value={activityData.budget}
                                                    disabled={
                                                        subHead.budget <= 0
                                                    }
                                                    onChange={(e) =>
                                                        handleSubheadBudget(
                                                        i,
                                                        index,
                                                        e
                                                        )
                                                    }
                                                    />
                                                </td>
                                                <td>
                                                    <button
                                                    className="btn btn-primary mx-2"
                                                    onClick={(e) =>
                                                        addNewActivity(
                                                        i,
                                                        "subhead"
                                                        )
                                                    }
                                                    >
                                                    <AddIcon />
                                                    </button>
                                                    <button
                                                    type="button"
                                                    className="btn btn-danger mx-2"
                                                    onClick={(e) =>
                                                        deleteNewActivity(
                                                        i,
                                                        index,
                                                        "subhead"
                                                        )
                                                    }
                                                    >
                                                    <DeleteForever />
                                                    </button>
                                                </td>
                                                </tr>
                                            )
                                            )}
                                        </tbody>
                                        </table>
                                    </div>
                                )}
                            {i > 0 && (
                            <Button
                                variant="danger"
                                size="sm"
                                className="mb-2"
                                onClick={() => deleteSubhead(i)}
                            >
                                Sub Head {i + 1}
                                <DeleteForever />
                            </Button>
                            )}
                        </>
                    );
                    })}

                    {formData.sub_heads.length < subheadsList.length ? (
                    <div className="col-sm-12 mt-3 mb-3 ">
                        <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={handleAddSubHead}
                        >
                        <i className="fa fa-plus"></i>
                        Add Sub Head
                        </button>
                    </div>
                    ) : ""}
                    <hr />
                    
                    <div className="col-sm-12 p-2">
                    <div className="row">
                        <div className="col-6">
                        <div className="input-group">
                            <label className="input-group-btn my-0">
                            <input
                                type="file"
                                className="form-control"
                                onChange={handleAttachmentChange}
                                name="attachment"
                                required
                                accept=".pdf,.jpeg,.jpg,.png"
                                multiple
                            />
                            </label>
                        </div>
                        </div>
                    </div>
                    </div>

                    <div className="col-sm-6 p-2">
                    <div className="border mt-3">
                        <div className="p-1 pt-2 pb-2">
                        <p>
                            <b>Total Provisional Budget </b>:{" "}
                            {provisionalBudget.current}
                        </p>
                        </div>
                    </div>
                    </div>

                    <div className="col-sm-6 p-2">
                    <div className="border mt-3">
                        <div className="p-1 pt-2 pb-2">
                        <p>
                            <b>Total Release Budget </b>:{" "}
                            {releaseBudget.current}
                        </p>
                        </div>
                    </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal size="lg" show={showModel} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Subhead : </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Container>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>
                      Scheme Code<span className="text-danger">*</span>
                    </Form.Label>
                    <select
                      className="form-control "
                      id="scheme_id"
                      name="scheme_id"
                      required
                      onChange={handleChange}
                    >
                      <option value="">Select Scheme Code</option>
                      {schemes.map((schemes) => {
                        return (
                          schemes.l2_status == 1 &&
                          schemes.l3_status == 1 && (
                            <option value={schemes.id} key={schemes.id}>
                              {schemes.code}
                            </option>
                          )
                        );
                      })}
                    </select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>
                      Subhead Name<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Subhead Name"
                      name="name"
                      value={formSubheadData.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>
                      Subhead Code<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Subhead Code"
                      name="code"
                      value={formSubheadData.code}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            CLOSE
          </Button>
          <Button variant="primary" onClick={handleSubhead}>
            SUBMIT
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddBudgetForm;
